import * as React from "react";
import "./styles.scss";
import {useState} from "react";

interface ISliderProps {
    images: string[];
    dots: boolean;
    onImageError?: string;
}

export default function ImageSlider(props: ISliderProps) {
    const [currentImageNumber, updateCurrentImageNumber] = useState<number>(0);
    function plusSlides(num: number) {
        if (currentImageNumber + num < 0) {
            updateCurrentImageNumber(props.images.length - 1);
        } else if (currentImageNumber + num >= props.images.length) {
            updateCurrentImageNumber(0);
        } else {
            updateCurrentImageNumber(currentImageNumber + num);
        }
    }
    return (
        <div>
            <div className="slideshow-container">
                {
                    props.images.map((imgUrl, index) => {
                        return (
                            <div className={`mySlides ${currentImageNumber === index ? "active d-block" : "fade"}`} key={index}>
                                <img src={imgUrl}
                                     style={{width: "100%", maxHeight: "260px"}}
                                     onError={(e: any) => {e.target.onerror = null; e.target.src = props.onImageError; }}
                                     alt={"icon"}
                                />
                            </div>
                        );
                    })
                }
                <a className="prev" onClick={() => plusSlides(-1)}>&#10094;</a>
                <a className="next" onClick={() => plusSlides(1)}>&#10095;</a>
                {props.dots && props.images.length > 1 && <div className={"position-absolute"} style={{bottom: "20px"}}>
                    {
                        props.images.map((img, index) => {
                            return <span key={index}
                                         className={`dot ${currentImageNumber === index && "active"}`}
                                         onClick={() => updateCurrentImageNumber(index)}
                                    />;
                        })
                    }
                </div>}
            </div>
        </div>
    );
}
